// Kneeva — JS propio (vanilla, sin librerías externas)
document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initCompare();
  initCounters();
  initProductForm();
  initQty();
});

/* Reveal on scroll (una sola IntersectionObserver compartida) */
function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (!('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        io.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15, rootMargin: '0px 0px -8% 0px' });
  els.forEach(function (el, i) {
    el.style.setProperty('--mt-delay', (i % 6) * 90 + 'ms');
    io.observe(el);
  });
}

/* Comparador antes/después con slider arrastrable */
function initCompare() {
  document.querySelectorAll('.mt-compare').forEach(function (wrap) {
    var after = wrap.querySelector('.mt-compare-after');
    var handle = wrap.querySelector('.mt-compare-handle');
    var range = wrap.querySelector('.mt-compare-range');
    if (!after || !range) return;

    function setPos(pct) {
      pct = Math.min(100, Math.max(0, pct));
      after.style.clipPath = 'inset(0 0 0 ' + pct + '%)';
      if (handle) handle.style.left = pct + '%';
    }
    range.addEventListener('input', function () { setPos(Number(range.value)); });

    var dragging = false;
    function pctFromClientX(clientX) {
      var rect = wrap.getBoundingClientRect();
      return ((clientX - rect.left) / rect.width) * 100;
    }
    function onMove(clientX) {
      if (!dragging) return;
      var pct = pctFromClientX(clientX);
      setPos(pct);
      range.value = pct;
    }
    wrap.addEventListener('pointerdown', function (e) { dragging = true; onMove(e.clientX); });
    window.addEventListener('pointermove', function (e) { if (dragging) onMove(e.clientX); });
    window.addEventListener('pointerup', function () { dragging = false; });

    setPos(Number(range.value || 50));
  });
}

/* Cifras animadas (count-up) */
function initCounters() {
  var els = document.querySelectorAll('[data-mt-counter]');
  if (!els.length) return;
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      var end = parseFloat(el.getAttribute('data-mt-counter')) || 0;
      var decimals = (el.getAttribute('data-mt-counter').split('.')[1] || '').length;
      var suffix = el.getAttribute('data-mt-suffix') || '';
      var dur = 1400;
      var start = null;
      function step(ts) {
        if (!start) start = ts;
        var p = Math.min(1, (ts - start) / dur);
        var eased = 1 - Math.pow(1 - p, 3);
        el.textContent = (end * eased).toFixed(decimals) + suffix;
        if (p < 1) requestAnimationFrame(step);
      }
      requestAnimationFrame(step);
      io.unobserve(el);
    });
  }, { threshold: 0.6 });
  els.forEach(function (el) { io.observe(el); });
}

/* Cantidad +/- en la página de producto */
function initQty() {
  document.querySelectorAll('.mt-qty').forEach(function (qty) {
    var input = qty.querySelector('input');
    qty.querySelectorAll('button').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var val = parseInt(input.value || '1', 10);
        val = btn.getAttribute('data-dir') === 'up' ? val + 1 : Math.max(1, val - 1);
        input.value = val;
      });
    });
  });
}

/* Selector de variantes + oferta pack + galería de la página de producto */
function initProductForm() {
  var root = document.querySelector('[data-mt-product]');
  if (!root) return;

  var variantsData = root.querySelector('[data-mt-variants]') || document.querySelector('[data-mt-variants]');
  var variants = [];
  try { variants = JSON.parse(variantsData.textContent); } catch (e) { variants = []; }

  var formEl = root.querySelector('form[action*="/cart/add"]') || root.querySelector('form');
  var optionPills = root.querySelectorAll('.mt-pill[data-option-index]');
  var optionPills2 = root.querySelectorAll('.mt-pill[data-option-index-2]');
  var idInput = root.querySelector('input[name="id"]');
  var priceNow = root.querySelector('.mt-price-now');
  var priceWas = root.querySelector('.mt-price-was');
  var priceBadge = root.querySelector('.mt-price-badge');
  var addBtn = root.querySelector('.mt-add-btn');
  var addBtnText = addBtn ? addBtn.querySelector('.mt-add-btn-text') : null;
  var mainMediaWrap = root.querySelector('.mt-product-main-media');
  var mainImg = mainMediaWrap ? mainMediaWrap.querySelector('img') : null;
  var defaultImg = mainMediaWrap ? mainMediaWrap.getAttribute('data-mt-default-img') : null;

  /* Datos del pack (pueden no existir si la oferta está desactivada) */
  var packVariantId = root.getAttribute('data-pack-variant-id');
  var packPriceStr = root.getAttribute('data-pack-price');
  var packCompareStr = root.getAttribute('data-pack-compare');
  var packBadgeStr = root.getAttribute('data-pack-badge');
  var packR1Label = root.getAttribute('data-pack-r1-label') || 'Rodillera 1';
  var packR2Label = root.getAttribute('data-pack-r2-label') || 'Rodillera 2';
  function isDuo() {
    var r = root.querySelector('[data-mt-pack] input[name="mt-pack-mode"]:checked');
    return !!(r && r.value === 'duo' && packVariantId);
  }

  var selected = {};
  root.querySelectorAll('.mt-pill.is-selected[data-option-index]').forEach(function (p) {
    selected[p.getAttribute('data-option-index')] = p.getAttribute('data-value');
  });
  var selected2 = {};

  function findVariant(sel) {
    return variants.find(function (v) {
      return Object.keys(sel).every(function (idx) { return v.options[idx] === sel[idx]; });
    });
  }
  function labelFor(sel) {
    return Object.keys(sel).sort().map(function (k) { return sel[k]; }).join(' / ');
  }

  var currency = root.getAttribute('data-currency') || 'EUR';
  var locale = document.documentElement.lang || 'es-ES';
  function money(cents) {
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency: currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2) + ' ' + currency;
    }
  }

  function markDisabled(pills, sel, attr) {
    pills.forEach(function (pill) {
      var idx = pill.getAttribute(attr);
      var test = Object.assign({}, sel);
      test[idx] = pill.getAttribute('data-value');
      var possible = variants.some(function (v2) {
        return Object.keys(test).every(function (i) { return v2.options[i] === test[i]; });
      });
      pill.classList.toggle('is-disabled', !possible);
    });
  }

  function updateUI() {
    var duo = isDuo();
    root.classList.toggle('is-pack-duo', duo);

    var v = findVariant(selected);
    if (v && idInput) idInput.value = v.id;

    if (duo) {
      if (priceNow && packPriceStr) priceNow.textContent = packPriceStr;
      if (priceWas) {
        priceWas.textContent = packCompareStr || '';
        priceWas.style.display = packCompareStr ? '' : 'none';
      }
      if (priceBadge) {
        priceBadge.textContent = packBadgeStr || '';
        priceBadge.style.display = packBadgeStr ? '' : 'none';
      }
      if (addBtn) addBtn.disabled = false;
      if (addBtnText) addBtnText.textContent = addBtnText.getAttribute('data-label-add');
    } else if (v) {
      if (priceNow) priceNow.textContent = money(v.price);
      if (priceWas) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceWas.textContent = money(v.compare_at_price);
          priceWas.style.display = '';
        } else {
          priceWas.style.display = 'none';
        }
      }
      if (priceBadge) {
        if (v.compare_at_price && v.compare_at_price > v.price) {
          priceBadge.textContent = '-' + Math.round((v.compare_at_price - v.price) / v.compare_at_price * 100) + '%';
          priceBadge.style.display = '';
        } else {
          priceBadge.style.display = 'none';
        }
      }
      if (addBtn) {
        addBtn.disabled = !v.available;
        if (addBtnText) addBtnText.textContent = v.available ? addBtnText.getAttribute('data-label-add') : addBtnText.getAttribute('data-label-sold-out');
      }
    }

    if (mainImg && v) {
      var wanted = v.image || defaultImg;
      if (wanted && mainImg.getAttribute('src') !== wanted) {
        mainImg.src = wanted;
        root.querySelectorAll('.mt-product-thumb').forEach(function (t) {
          t.classList.toggle('is-active', t.getAttribute('data-full') === wanted);
        });
      }
    }

    markDisabled(optionPills, selected, 'data-option-index');
    markDisabled(optionPills2, selected2, 'data-option-index-2');
  }

  optionPills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var idx = pill.getAttribute('data-option-index');
      selected[idx] = pill.getAttribute('data-value');
      root.querySelectorAll('.mt-pill[data-option-index="' + idx + '"]').forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      updateUI();
    });
  });

  optionPills2.forEach(function (pill) {
    pill.addEventListener('click', function () {
      var idx = pill.getAttribute('data-option-index-2');
      selected2[idx] = pill.getAttribute('data-value');
      root.querySelectorAll('.mt-pill[data-option-index-2="' + idx + '"]').forEach(function (p) { p.classList.remove('is-selected'); });
      pill.classList.add('is-selected');
      updateUI();
    });
  });

  /* Rodillera 2 arranca con la misma selección que la 1 */
  optionPills2.forEach(function (pill) {
    var idx = pill.getAttribute('data-option-index-2');
    var want = selected[idx];
    if (want !== undefined && pill.getAttribute('data-value') === want && selected2[idx] === undefined) {
      selected2[idx] = want;
      pill.classList.add('is-selected');
    }
  });
  /* Respaldo: si algún grupo quedó sin elegir, coge el primer valor */
  optionPills2.forEach(function (pill) {
    var idx = pill.getAttribute('data-option-index-2');
    if (selected2[idx] === undefined) {
      selected2[idx] = pill.getAttribute('data-value');
      pill.classList.add('is-selected');
    }
  });

  root.querySelectorAll('[data-mt-pack] input[name="mt-pack-mode"]').forEach(function (r) {
    r.addEventListener('change', function () {
      root.querySelectorAll('[data-mt-pack] .mt-pack-opt').forEach(function (o) {
        o.classList.toggle('is-active', o.getAttribute('data-pack-mode') === r.value);
      });
      updateUI();
    });
  });

  if (formEl) {
    formEl.addEventListener('submit', function (e) {
      if (!isDuo()) return;
      e.preventDefault();
      /* El pack entra al carrito como las 2 variantes reales del producto
         (así la app de dropshipping las reconoce); el precio de pack lo pone
         el descuento automático "Pack Dúo" de Shopify. */
      var v1 = findVariant(selected);
      var v2 = findVariant(selected2);
      if (!v1 || !v2) return;
      if (addBtn) addBtn.disabled = true;
      var items = v1.id === v2.id
        ? [{ id: Number(v1.id), quantity: 2 }]
        : [{ id: Number(v1.id), quantity: 1 }, { id: Number(v2.id), quantity: 1 }];
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function (res) { return res.json(); }).then(function () {
        window.location = '/cart';
      }).catch(function () {
        window.location = '/cart';
      });
    });
  }

  updateUI();

  /* Galería: click en miniatura cambia la imagen principal */
  root.querySelectorAll('.mt-product-thumb').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      root.querySelectorAll('.mt-product-thumb').forEach(function (t) { t.classList.remove('is-active'); });
      thumb.classList.add('is-active');
      var full = thumb.getAttribute('data-full');
      if (mainImg && full) mainImg.src = full;
    });
  });
}
